module.exports = __webpack_public_path__ + "images/torres-strait-islanders-flag.svg";